import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import DepartmentApi from '../server/DepartmentApi';


function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}


const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.DEPARTMENT_LIST);
        const handleError = createErrorHandler(ActionTypes.DEPARTMENT_LIST_ERROR);

        return DepartmentApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.DEPARTMENT_INFO);
        const handleError = createErrorHandler(ActionTypes.DEPARTMENT_INFO_ERROR);

        return DepartmentApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getMembers: (id, params, clearAll = true) => {
        const types = {
            request: ActionTypes.DEPARTMENT_MEMBERS_LIST_REQUEST,
            success: ActionTypes.DEPARTMENT_MEMBERS_LIST_SUCCESS,
            failure: ActionTypes.DEPARTMENT_MEMBERS_LIST_FAILURE
        };

        return CentricDispatcher.dispatchAsync(DepartmentApi.getMembers(id, params), types, {id, params, clearAll});
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.DEPARTMENT_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.DEPARTMENT_INFO_ERROR);

        return DepartmentApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.DEPARTMENT_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.DEPARTMENT_UPDATE_ERROR);

        return DepartmentApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    setDefault: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.DEPARTMENT_DEFAULT, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.DEPARTMENT_DEFAULT_ERROR);

        return DepartmentApi.setDefault(id)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.DEPARTMENT_DELETE);
        const handleError = createErrorHandler(ActionTypes.DEPARTMENT_DELETE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return DepartmentApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: function(searchText, params) {
        const handleSuccess = createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED, ActionTypes.DEPARTMENT_LIST);
        const handleError = createErrorHandler(ActionTypes.SEARCH_ERROR);
        
        return DepartmentApi.search(searchText, params)
            .then(handleSuccess, handleError);
    },
};
